import { render, staticRenderFns } from "./SupportAI.vue?vue&type=template&id=1a0fd93c&"
import script from "./SupportAI.vue?vue&type=script&lang=js&"
export * from "./SupportAI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports